// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Goldplay-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Goldplay-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/Goldplay-SemiBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/Goldplay-Black.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/Goldplay-Alt-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/Goldplay-Alt-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/fonts/Goldplay-Alt-SemiBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/fonts/Goldplay-Alt-Black.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family:'Goldplay Medium';
  src: local('goldplay'),url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
}

@font-face {
  font-family: 'Goldplay Regular';
  src: local('goldplay'),url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype')
}

@font-face {
  font-family: 'Goldplay Semibold';
  src:local('goldplay'),url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('opentype')
}

@font-face {
  font-family: 'Goldplay Black';
  src:local('goldplay'),url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('opentype')
}

@font-face {
  font-family: 'Goldplay Alt Medium';
  src:local('goldplay alt'),url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('opentype')
}

@font-face {
  font-family: 'Goldplay Alt Regular';
  src:local('goldplay alt'),url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('opentype')
}

@font-face {
  font-family: 'Goldplay Alt Semibold';
  src:local('goldplay alt'),url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('opentype')
}

@font-face {
  font-family: 'Goldplay Alt Black';
  src:local('goldplay alt'),url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('opentype')
}


:root {
  --primary: #1f3447;
  --secundary: #ff6600;
  --tertiary: #cfcdb4;
  --linear: linear-gradient(115.27deg, #ffc000 -21.38%, #ff6600 93.83%);

  --white: #ffff;
  --gray-1: #f1f3f5;
  --gray-2: #F2F2F2;
  --gray-3: #e9ecef;
  --gray-4: #dee2e6;
  --gray-5: #ced4da;
  --gray-6: #adb5bd;
  --gray-7: #868e96;
  --gray-8: #6C6E6F;
  --gray-9: #848484;
  --gray-10: #495057;
  --gray-11: #343a40;
  --gray-12: #212529;

  --success-1: #26a541;
  --success-2: #3fd65f;
  --warning: #ffab00;
  --error: #cf3e3e;

  
  --goldplay-regular: 'Goldplay Regular','Nunito', sans-serif;
  --goldplay-medium: 'Goldplay Medium','Nunito', sans-serif;
  --goldplay-semibold: 'Goldplay Semibold','Nunito', sans-serif;
  --goldplay-black: 'Goldplay Black', 'Nunito', sans-serif;
  --goldplay-regular-alt: 'Goldplay Alt Regular', 'Nunito', sans-serif;
  --goldplay-medium-alt: 'Goldplay Alt Medium', 'Nunito', sans-serif;
  --goldplay-semibold-alt: 'Goldplay Alt Semibold', 'Nunito', sans-serif;
  --goldplay-black-alt: 'Goldplay Alt Black', 'Nunito', sans-serif;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body,
input,
textarea,
button{
  font-family: var(--goldplay-regular);
  font-weight: 400;
  font-size: 1rem;
}
body::-webkit-scrollbar {
  width: 20px;
}

body::-webkit-scrollbar-track {
  background-color: transparent;
}

body::-webkit-scrollbar-thumb {
  background-color: #d6dee1;
  border-radius: 20px;
  border: 6px solid transparent;
  background-clip: content-box;
}
`, "",{"version":3,"sources":["webpack://./src/global.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,iFAAiF;AACnF;;AAEA;EACE,+BAA+B;EAC/B;AACF;;AAEA;EACE,gCAAgC;EAChC;AACF;;AAEA;EACE,6BAA6B;EAC7B;AACF;;AAEA;EACE,kCAAkC;EAClC;AACF;;AAEA;EACE,mCAAmC;EACnC;AACF;;AAEA;EACE,oCAAoC;EACpC;AACF;;AAEA;EACE,iCAAiC;EACjC;AACF;;;AAGA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,qEAAqE;;EAErE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;;EAElB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;;;EAGhB,2DAA2D;EAC3D,yDAAyD;EACzD,6DAA6D;EAC7D,wDAAwD;EACxD,oEAAoE;EACpE,kEAAkE;EAClE,sEAAsE;EACtE,gEAAgE;AAClE;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;;;;EAIE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;AAC9B","sourcesContent":["@font-face {\n  font-family:'Goldplay Medium';\n  src: local('goldplay'),url(./assets/fonts/Goldplay-Medium.otf) format('opentype');\n}\n\n@font-face {\n  font-family: 'Goldplay Regular';\n  src: local('goldplay'),url(./assets/fonts/Goldplay-Regular.otf) format('opentype')\n}\n\n@font-face {\n  font-family: 'Goldplay Semibold';\n  src:local('goldplay'),url(./assets/fonts/Goldplay-SemiBold.otf) format('opentype')\n}\n\n@font-face {\n  font-family: 'Goldplay Black';\n  src:local('goldplay'),url(./assets/fonts/Goldplay-Black.otf) format('opentype')\n}\n\n@font-face {\n  font-family: 'Goldplay Alt Medium';\n  src:local('goldplay alt'),url(./assets/fonts/Goldplay-Alt-Medium.otf) format('opentype')\n}\n\n@font-face {\n  font-family: 'Goldplay Alt Regular';\n  src:local('goldplay alt'),url(./assets/fonts/Goldplay-Alt-Regular.otf) format('opentype')\n}\n\n@font-face {\n  font-family: 'Goldplay Alt Semibold';\n  src:local('goldplay alt'),url(./assets/fonts/Goldplay-Alt-SemiBold.otf) format('opentype')\n}\n\n@font-face {\n  font-family: 'Goldplay Alt Black';\n  src:local('goldplay alt'),url(./assets/fonts/Goldplay-Alt-Black.otf) format('opentype')\n}\n\n\n:root {\n  --primary: #1f3447;\n  --secundary: #ff6600;\n  --tertiary: #cfcdb4;\n  --linear: linear-gradient(115.27deg, #ffc000 -21.38%, #ff6600 93.83%);\n\n  --white: #ffff;\n  --gray-1: #f1f3f5;\n  --gray-2: #F2F2F2;\n  --gray-3: #e9ecef;\n  --gray-4: #dee2e6;\n  --gray-5: #ced4da;\n  --gray-6: #adb5bd;\n  --gray-7: #868e96;\n  --gray-8: #6C6E6F;\n  --gray-9: #848484;\n  --gray-10: #495057;\n  --gray-11: #343a40;\n  --gray-12: #212529;\n\n  --success-1: #26a541;\n  --success-2: #3fd65f;\n  --warning: #ffab00;\n  --error: #cf3e3e;\n\n  \n  --goldplay-regular: 'Goldplay Regular','Nunito', sans-serif;\n  --goldplay-medium: 'Goldplay Medium','Nunito', sans-serif;\n  --goldplay-semibold: 'Goldplay Semibold','Nunito', sans-serif;\n  --goldplay-black: 'Goldplay Black', 'Nunito', sans-serif;\n  --goldplay-regular-alt: 'Goldplay Alt Regular', 'Nunito', sans-serif;\n  --goldplay-medium-alt: 'Goldplay Alt Medium', 'Nunito', sans-serif;\n  --goldplay-semibold-alt: 'Goldplay Alt Semibold', 'Nunito', sans-serif;\n  --goldplay-black-alt: 'Goldplay Alt Black', 'Nunito', sans-serif;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody,\ninput,\ntextarea,\nbutton{\n  font-family: var(--goldplay-regular);\n  font-weight: 400;\n  font-size: 1rem;\n}\nbody::-webkit-scrollbar {\n  width: 20px;\n}\n\nbody::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\nbody::-webkit-scrollbar-thumb {\n  background-color: #d6dee1;\n  border-radius: 20px;\n  border: 6px solid transparent;\n  background-clip: content-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
